// extracted by mini-css-extract-plugin
export default {"title":"OverviewPage_title__hd7EP","heroCards":"OverviewPage_heroCards__txBP-"};